import { render, staticRenderFns } from "./travelPaymentInfo.vue?vue&type=template&id=37954088&scoped=true&"
import script from "./travelPaymentInfo.vue?vue&type=script&lang=js&"
export * from "./travelPaymentInfo.vue?vue&type=script&lang=js&"
import style0 from "./travelPaymentInfo.vue?vue&type=style&index=0&id=37954088&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37954088",
  null
  
)

export default component.exports